import styled from 'styled-components';
import { colors } from '@config/colors';
import { spacing } from '@config/spacing';
import { typography } from '@config/typography';
import { zIndex, app } from '@config/constants';
import { media } from '@config/breakpoints';

export const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: ${zIndex.sticky};
  background: ${colors.glassSurface};
  backdrop-filter: blur(var(--glass-blur, 20px));
  border-bottom: 1px solid ${colors.glassBorder};
  box-shadow: 0 4px 12px ${colors.shadowSoft};
  height: ${app.headerHeight};
`;

export const HeaderLink = styled.a`
  display: block;
  height: 100%;
  text-decoration: none;
  color: inherit;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.md};
  max-width: ${app.maxContentWidth};
  margin: 0 auto;
  padding: ${spacing.md} ${spacing.xl};
  height: 100%;

  ${media.md} {
    padding: ${spacing.md} ${spacing['2xl']};
  }
`;

export const LogoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${colors.brand.primary};
  color: ${colors.highlight.light};
  box-shadow: 0 12px 24px ${colors.brandOverlay20};
  animation: gentlePulse 9s ease-in-out infinite;

  @keyframes gentlePulse {
    0%, 100% {
      transform: scale(1);
      opacity: 1;
      background: ${colors.brand.primary};
    }
    50% {
      transform: scale(1.05);
      opacity: 0.9;
      background: ${colors.highlight.light};
    }
  }

  svg {
    width: 70%;
    height: 70%;
    animation: iconColorPulse 9s ease-in-out infinite;
  }

  @keyframes iconColorPulse {
    0%, 100% { color: ${colors.highlight.light}; }
    50% { color: ${colors.brand.primary}; }
  }
`;

export const LogoText = styled.h1`
  font-family: 'Poppins', ${typography.fontFamily.heading};
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeights.semibold};
  letter-spacing: ${typography.letterSpacing.tight};
  color: ${colors.neutral.extraDark};
  margin: 0;

  ${media.sm} {
    font-size: ${typography.fontSize.xl};
  }
`;
